﻿
window.allowRenderOnLogin = true;

